import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import moment from 'moment';
import * as _ from "lodash";
import swal from "sweetalert";
import serialize from "form-serialize";
import classnames from "classnames";
import { connect } from "react-redux";
import {
  useHistory,
  withRouter,
  Route,
  Redirect,
  Switch,
  Link,
} from "react-router-dom";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import WallpaperIcon from "@material-ui/icons/Wallpaper";
import VideoCallIcon from "@material-ui/icons/VideoCall";
import MicIcon from "@material-ui/icons/Mic";

import Loader from "../loaders/loader";
import Questionnaire from "./Questionnaire";
import EvidenceCapture from "./EvidenceCapture";
import ApiServices from "../../api/api";
import OffileDb from '../../config/pouchDB';
import { db, storageRef } from "../../service/firebase";


class SurveyForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      serviceDetails: [],
      sectionDetails: [],
      lat: "",
      lng: "",
      imageURLs: [],
      audioURLs: [],
      videoURLs: [],
      offlineDate: '',
      isSectionEnabled: false,
      inlineForm: false,
      adminObj: JSON.parse(localStorage.getItem('adminobj')) != null ? JSON.parse(localStorage.getItem('adminobj')) : {}

    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateUrl = this.updateUrl.bind(this);

  }

  componentDidMount() {
    var self = this;

    /**START GET LATITUBE & LONGITUDE */
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    navigator.geolocation.getCurrentPosition(
      function (position) {
        self.setState({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          zoom: 13
        });
      },
      null,
      options
    );
    /**END GET LATITUBE & LONGITUDE */
    console.log(this.props)

    if (this.props.inlineForm) {
      this.setState({ inlineForm: true })
      this.getSectionBySurveyId(this.props.serviceObj);
    } else {
      if (!this.props.location.state) {
        this.props.history.goBack();
      } else {
        this.getSectionBySurveyId(this.props.location.state);
        //this.getQuestionsBySurveyId(this.props.location.state);
      }
    }
  }

  getSectionBySurveyId(obj) {

    this.setState({ isSectionEnabled: obj.isSectionEnabled })
    this.loadOfflineData(obj.id)

  }

  getSectionBySurveyIdApi(id) {
    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
        languageId: this.props.langId,
        surveyId: id,
      };
      console.log(param)

      ApiServices.getSectionBySurveyId(param).then((res) => {
        try{
          if (res.data.data.length > 0) {
            this.setState({
              sectionDetails: res.data.data[0],
              isLoading: false,
            });
            this.getQuestionsBySurveyId(res.data.data[0]);
          }
        }catch(err){
          console.log("err::", err)
        }
      });
    }
  }

  getQuestionsBySurveyId(obj) {

    if (navigator.onLine) {
      var localid = "surveyDetails" + obj.surveyId
      this.setState({ isLoading: true });
      var param = {
        communityId: this.props.communityuid,
        languageId: this.props.langId,
        sectionId: obj.id,
        surveyId: obj.surveyId
      };

      ApiServices.getSurveySectionQuestionsBySectionId(param).then((res) => {
        try{
          if (res.data.data.length > 0) {
            this.setState({
              serviceDetails: res.data.data,
              isLoading: false,
            });
            OffileDb.setData(localid, res.data.data)
            //this.loadOfflineSurveyForm(obj)
          }
        }catch(err){
          console.log("err::", err)
        }
      });
    } else {
      this.loadOfflineData(obj.surveyId)
    }
  }

  loadOfflineData(surveyid) {
    var that = this
    const { t } = this.props;
    var id = "surveyDetails" + surveyid
    OffileDb.getData(id).then(function (result) {
      if (result.status && result.status == 404) {
        that.getSectionBySurveyIdApi(surveyid)
      } else {
        that.setState({
          serviceDetails: result.data,
          isLoading: false
        });
        //that.loadOfflineSurveyForm(obj)
      }
    });
  }

  saveOfflineServiceForm(params) {
    var self = this;
    const { t } = this.props;
    swal({
      title: t("Unstable internet connection"),
      text: t("Issue reported successfully in offline mode"),
      icon: "success",
      button: t("ok"),
    }).then((val) => {
      self.saveOfflineReportList(params)
      //var id = "surveyForm-" + params.surveyId
      //OffileDb.setData(id, params)
      //self.props.history.push("/layout/survey");
    });
  }

  saveOfflineReportList(params) {
    var self = this;
    const { tablist } = this.props;
    params.surveyName = this.props.location.state.name
    OffileDb.getData('surveyOfflineReportList').then(function (result) {
      if (!result.status && result.status != 404) {
        result.data.push(params)
        var updatedata = result.data;
        OffileDb.setData('surveyOfflineReportList', updatedata)
        //self.props.history.push("/layout/survey");
      } else {
        OffileDb.setData('surveyOfflineReportList', [params])
        //self.props.history.push("/layout/survey");
      }
      if (self.state.inlineForm) {
        if (tablist.length == 1) {
          self.props.history.push("/layout");
        } else {
          self.props.handleChangeIndex(1);
        }
      } else {
        self.props.history.push("/layout/survey");
      }
    })
  }

  // loadOfflineSurveyForm(obj) {
  //   var that = this;
  //   const { t } = this.props;
  //   var formID = "surveyForm-" + obj.id;
  //   var serviceDetails = this.state.serviceDetails;
  //   OffileDb.getData(formID).then(function (formData) {
  //     if (!formData.status && formData.status != 404) {
  //       console.log(formData)
  //       var questionArr = formData.data.questionResponse
  //       serviceDetails.questionnaire = questionArr
  //       that.setState({
  //         offlineDate: formData.data.offlineDate,
  //         serviceDetails: serviceDetails,
  //         isLoading: false,
  //       });
  //       swal({
  //         text: t("Offline data synced successfully."),
  //         icon: "success",
  //         button: "Ok",
  //       }).then((val) => {
  //         console.log(val)
  //       });
  //     }
  //   })
  // }

  handleSubmit(event) {
    event.preventDefault();
    var self = this;
    const { t } = this.props;
    let { lat, lng } = this.state;
    let serviceDetails = _.cloneDeep(this.state.serviceDetails);
    let { communityuid, langId } = this.props;
    const form = event.target;
    var str = serialize(form);
    var formObj = serialize(form, { hash: true });

    let questionnaireArr = [];

    var questionarr = [];
    serviceDetails.forEach(obj => {
      questionarr = [...questionarr, ...obj.questionnaire]
    })

    console.log(formObj)
    questionarr.forEach((qobj) => {
      var id = qobj.id
      var value = formObj[id] != undefined ? formObj[id] : '';
      qobj.response = {
        value: Array.isArray(value) ? value : [value]
      }
      qobj.responseExtension = {
        audioURLs: self.state.audioURLs,
        comments: "",
        imageURLs: self.state.imageURLs,
        reviews: "",
        summary: "",
        videoURLs: self.state.videoURLs,
      };
      if (qobj.dependentQuestionsList.length > 0) {
        this.checkDependentResponsed(qobj, formObj)
      }
      questionnaireArr.push(qobj);

    })

    // Object.entries(formObj).forEach((entry) => {
    //   const [key, value] = entry;
    //   let selectedQuestionnaire = {};
    //   let quesid = key.split("-")[1];
    //   let depend = key.split("-")[0];
    //   if (depend != 'dependant') {

    //     selectedQuestionnaire = questionarr.find((quesobj) => {
    //       return quesobj.id == quesid;
    //     });
    //     selectedQuestionnaire.response = {
    //       value: Array.isArray(value) ? value : [value],
    //     };
    //     selectedQuestionnaire.responseExtension = {
    //       audioURLs: self.state.audioURLs,
    //       comments: "",
    //       imageURLs: self.state.imageURLs,
    //       reviews: "",
    //       summary: "",
    //       videoURLs: self.state.videoURLs,
    //     };
    //     if (selectedQuestionnaire.dependentQuestionsList.length > 0) {
    //       selectedQuestionnaire.dependentQuestionResponse = this.getDependentResponse(selectedQuestionnaire.dependentQuestionsList, selectedQuestionnaire.id, formObj)
    //     }
    //     questionnaireArr.push(selectedQuestionnaire);
    //   }

    // });

    var now = new Date();
    let params = {
      // caseStatus: {
      //   id: "1",
      //   status: "Open",
      // },
      communityId: communityuid,
      languageId: langId,
      questionResponse: questionnaireArr,
      sectionId: serviceDetails[0].sectionId,
      surveyId: serviceDetails[0].surveyId,
      offlineDate: this.state.offlineDate != '' && this.state.offlineDate ? this.state.offlineDate : moment(now).format('YYYY-MM-DD HH:mm:ss'),
      userDetails: {
        location: {
          coordinates: [lat, lng],
        },
        serialNumber: localStorage.getItem("deviceuuid"),
      },
      userId: JSON.parse(localStorage.getItem("obj")).userId,
    };
    console.log(params)
    // this.refs.submitbtn.setAttribute("disabled", "disabled");
    // if (navigator.onLine) {
    //   this.submitApiData(params)
    // } else {
    //   this.saveOfflineServiceForm(params)
    // }
    if (navigator.onLine) {
      if (Object.keys(formObj).length != 0) {
        if (this.checkValidation(params)) {
          this.refs.submitbtn.setAttribute("disabled", "disabled");
          this.submitApiData(params)
        } else {
          swal({
            text: t("Please fill all mandatory questions"),
            icon: "warning",
            button: t("ok"),
          })
        }
      } else {
        swal({
          text: t("Please select an option for reporting an issue"),
          icon: "warning",
          button: t("ok"),
        })
      }
    } else {
      this.refs.submitbtn.setAttribute("disabled", "disabled");
      this.saveOfflineServiceForm(params)
    }
  }

  checkDependentResponsed(questionobj, obj) {
    if (questionobj.dependentQuestionsList) {
      questionobj.dependentQuestionResponse = this.getDependentResponse(questionobj.dependentQuestionsList, obj)
      if (questionobj.dependentQuestionsList) {
        questionobj.dependentQuestionsList.forEach(q => {
          this.checkDependentResponsed(q, obj)
        })

      }
    }
  }

  getDependentResponse(depenArr, formObj) {
    var arr = []
    depenArr.forEach(obj => {
      var id = obj.id
      if (formObj[id] != undefined) {
        obj.response = {
          value: Array.isArray(formObj[id]) ? formObj[id] : [formObj[id]],
        };
        arr.push(obj)
      }
    })
    return arr;
  }

  checkValidation(params) {
    var flag = true
    if (params.questionResponse.length > 0) {
      params.questionResponse.forEach(obj => {
        if (obj.isMandatory && obj.response.value[0] == "") {
          flag = false
        }
      })
    } else {
      flag = false
    }
    return flag
  }

  increaseSurveyCount() {
    let { communityuid } = { ...this.props };
    let channel = `${communityuid}/survey/`;

    let data = {
      timestamp: Date.now(),
      communityid: communityuid,
      userid: JSON.parse(localStorage.getItem("obj")).userId,
      elType: 'survey'
    };

    db.ref(channel).push(data);
  }

  submitApiData(params) {
    //var id = "surveyForm-" + params.surveyId;
    const { t } = this.props;
    const { tablist } = this.props;
    var self = this;
    ApiServices.addCaseSetForSurveyUsingPOST(params).then((res) => {
      try{
        if (res.data.status == 200) {
          this.increaseSurveyCount();
          //OffileDb.removeData(id)
          swal({
            text: t("Thank you for your response"),
            icon: "success",
            button: t("ok"),
          }).then((val) => {
            if (self.state.inlineForm) {
              if (tablist.length == 1) {
                self.props.history.push("/layout");
              } else {
                self.props.handleChangeIndex(1);
              }
            } else {
              self.props.history.push("/layout/survey");
            }

          });
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }


  // getDependentResponse(depenArr, parantid, formObj) {
  //   var arr = []
  //   depenArr.forEach(obj => {
  //     var id = 'dependant-' + parantid + '-' + obj.id
  //     if (formObj[id] != undefined) {
  //       obj.response = {
  //         value: Array.isArray(formObj[id]) ? formObj[id] : [formObj[id]],
  //       };
  //       arr.push(obj)
  //     }
  //   })
  //   return arr;
  // }

  updateUrl(url, type) {
    if (type == 'image') {
      var arr = this.state.imageURLs;
      arr.push(url)
      this.setState({ imageURLs: arr })
    } else if (type == 'video') {
      var arr = this.state.videoURLs;
      arr.push(url)
      this.setState({ videoURLs: arr })
    } else if (type == 'audio') {
      var arr = this.state.audioURLs;
      arr.push(url)
      this.setState({ audioURLs: arr })
    }
  }



  render() {
    const { location } = { ...this.props };
    const { t } = this.props;
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    if (!location.state) {
    }

    console.log(this.state.serviceDetails)

    return (
      <div className="gk-page getknowledge-page getknowledgeable_page">

        {
          templateID == 1 && !this.props.inlineForm && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }

        <div className="gridcontainer">
{/* 
        {this.props.location.state ? <div className="surveytitlediv">{this.props.location.state.name}</div>: this.props.serviceObj ? <div className="surveytitlediv">{this.props.serviceObj.name}</div>:<div className="surveytitlediv">{this.state.sectionDetails.name}</div>
            } */}
            {/* { this.props.serviceObj ? <div className="surveytitlediv">{this.props.serviceObj.name}</div>:<div className="surveytitlediv">{this.state.sectionDetails.name}</div>
            } */}
          {
            this.state.isSectionEnabled && (
              <div className="sectiontiltediv" style={{ background: this.props.componentbgcolor }}>
                <p className="zero">{t(this.state.sectionDetails.name)}</p>
              </div>
            )
          }

          <form id="surveyform" className="surveyform" onSubmit={this.handleSubmit}>
            <div className={templateID == 2 ? "forumlistdivholder reportlistformdivholder" : "forumlistdivholder getinvo_inner_questiondiv"}>
              {this.state.isLoading ? (
                <Loader isLoading={this.state.isLoading} />
              ) : this.state.serviceDetails.length == 0 ? (
                <p>{/*t('No Data Found')*/}</p>
              ) : (
                this.state.serviceDetails.map((sObj) => {
                  return sObj.questionnaire.map((Obj) => {
                    if (Obj.question) {
                      return <Questionnaire question={Obj} updateUrl={this.updateUrl} />;
                    }

                  })
                })
              )}
            </div>
            {
              Object.keys(this.state.adminObj).length != 0 && (
                <>
                  <div className="text-center reportsubmitbtn-divholder">
                    {templateID == 1 && <EvidenceCapture updateUrl={this.updateUrl}></EvidenceCapture>}
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disableElevation
                      className="reportsubmitbtn"
                      style={colorStyles}
                      ref="submitbtn"
                    >
                      {t('submit')}
                    </Button>
                  </div>

                  {
                    templateID != 1 && (
                      <div className="reportform-actionbtndiv">
                        <EvidenceCapture updateUrl={this.updateUrl}></EvidenceCapture>
                      </div>
                    )
                  }
                </>
              )
            }

          </form>
        </div>
      </div>
    );
  }
}

// export default withRouter(ServiceForm);

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
    componentbgcolor: storeState.componentbgcolor
  };
};

const transSurveyForm = withTranslation()(SurveyForm);
const ThemeSurveyForm = withTheme(transSurveyForm);
// const FinalServiceForm = withStyles(ThemeServiceForm);
const routeSurveyForm = withRouter(ThemeSurveyForm);
export default connect(mapStateToProps, {})(routeSurveyForm);
